import React from 'react';
import { pureRender } from 'epic-alt-utils';
import { NavActions } from '../../actions';
import autobind from 'core-decorators/lib/autobind';
import { SearchExtension } from '../';
import './search.sass';

@pureRender
export default class Search extends React.Component {

    @autobind
    showSearch(e) {
        e.preventDefault();
        if (!this.props.isActive) {
            NavActions.searchActive(true);
            NavActions.mobileNavActiveLinks(false);
        } else {
            NavActions.searchActive(false);
            if (this.context.isMobile) {
                NavActions.mobileNavActiveLinks(true);
            }
        }

        //Reset all other clickable items
        NavActions.egNavActive(false);
        NavActions.tabletNavActive(false);
        NavActions.mobileLocaleActive(false);
        NavActions.mobileActiveLinkIndex(null);
        NavActions.mobileUserActive(false);
    }

    render() {
        const messages = this.context.messages || {};
        const isActive = this.props.isActive;
        const desktopOrTabletActive = isActive && !this.context.isMobile;
        return (
            <div
                id="search"
                className="no-before">
                {!this.context.isMobile ?
                    <SearchExtension
                        active={isActive}
                        onSearch={this.props.onSearch}
                        hideSearch={this.showSearch}
                        searchMaxWidth={this.props.searchMaxWidth}/> : ''}

                <div
                    id="searchIcon"
                    className={`bg-color ${desktopOrTabletActive ? 'no-before' : 'accent-bg-color-before'} ${isActive ? 'active' : ''}`}>
                    <a
                        href="#"
                        onClick={this.showSearch}
                        title={messages.search}
                        className="text-color-hover">
                        <i className={`eg-header-icon-search ${this.context.isMobile && isActive ? 'hidden' : ''}`}></i>
                        <i className={`eg-header-icon-close ${this.context.isMobile && !isActive ? 'hidden' : ''}`}></i>
                    </a>
                </div>
            </div>
        );
    }
}

Search.propTypes = {
    isActive: React.PropTypes.bool,
    onSearch: React.PropTypes.func,
    searchMaxWidth: React.PropTypes.number
};

Search.contextTypes = {
    messages: React.PropTypes.object,
    isMobile: React.PropTypes.bool
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/search/Search.js
 **/